import {
  Component,
  ElementRef,
  ViewChildren,
  ViewChild,
  QueryList,
  AfterViewInit,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TiktokCreatorEmbedComponent } from '../components/tiktok-creator-embed/tiktok-creator-embed.component';
import {
  TikTokCarouselComponent,
  TikTokItem,
} from './../components/tik-tok-carousel/tik-tok-carousel.component';
import { FooterComponent } from '../shared/footer/footer.component';

interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-promotor',
  imports: [FormsModule, TikTokCarouselComponent, FooterComponent],
  templateUrl: './promotor.component.html',
  styleUrl: './promotor.component.scss',
})
export class PromotorComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('animatedElement') animatedElements!: QueryList<ElementRef>;
  @ViewChild('parallaxBg') parallaxBg!: ElementRef;
  private observer: IntersectionObserver | null = null;
  private mouseX = 0;
  private mouseY = 0;
  private scrollY = 0;

  isMenuOpen = false;
  simuladorMonto = '5000';
  simuladorPlazo = 16;
  pagoSemanal = 0;
  pagoTotal = 0;
  pagoSemanalTexto = '$0';
  pagoTotalTexto = '$0';
  readonly minValorSimulador = 5000;
  readonly maxValorSimulador = 60000;
  readonly plazos = [
    { name: '16 semanas', code: 16 },
    { name: '20 semanas', code: 20 },
    { name: '24 semanas', code: 24 },
    { name: '28 semanas', code: 28 },
  ];
  tiktoks: TikTokItem[] = [
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7585290639345044792',
      img: '/assets/tiktok/promotor/1.jpg',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7579338111730126136',
      img: '/assets/tiktok/promotor/2.jpg',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7571174427862289720',
      img: '/assets/tiktok/promotor/3.jpg',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7518085511307627781',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oQWSaQVmVUZxB28idAFBLLMviaBUBFyvIKExQ~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=J92PT%2B2gGKBh1QHUDOlnld6aFdU%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7524879357026864389',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oMiQecu3CMe2fSU2MUXGgvgQDJj3G9R8g0CQd3~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=pwPtwUUnBqjrb8jeFRWvDIBtNYk%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
    },
    /*{
      link: 'https://www.tiktok.com/@teu.mx/video/7557027113983839500',
      img: '/assets/tiktok/promotor/4.jpg',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7554073614841236792',
      img: '/assets/tiktok/promotor/5.jpg',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7552589069545426187',
      img: '/assets/tiktok/promotor/6.jpg',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7549605045289880838',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oAZwQxEunFVWEBJXhonLB2QpXEI0fBiDQLK5eJ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=u0vUwjKYt1OoDv%2F6bjC0VOxCsyg%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
 
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7543775524456369464',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oE4DxYEVnMS1RhSegAfhvZgIDfJSFCEPZCNRbQ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=l46GUKK3TiH71d9gB5aFodb3Gv4%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7541487200379129093',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/o0foyaBewEDq1otEGvF6tIOrByBlQQBpLXDJVE~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=kM3d6kCttYizTZxKvuPalIBmGp4%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7540080261292215558',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/osKBBiQREmoCQnwxIBjY7JiA1oSbvBf70yELeG~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=kIHIx6SbQA4cK9pivtG%2BpZgt32c%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7539291674577620230',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/okOY7WiUbEBBr9BCjR0of8iD0gIwA39gk5dH8A~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=%2Bjsohcb75He2eXtLRemsQgX5LlA%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7537860176620096824',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oQkFfeG6LToVbt3NtGmyTEeAHUGIQkEeAi2JAI~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=RPrYaNMC9HtlYSCMcnNuljqX0%2FY%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7534050211312700677',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oEmBLsDVF6ECjUOpIBFiEB1wf9qEIJBfQolLDE~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=Jsng60V8J4IQMR2IkHvil3xccJU%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7533385308864269624',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oEWsEJiBoUfBFxmB9ofLwA5IgYiAkBEi9CBdOQ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=GA3hJkwmF0QquOdu%2B%2BaBQOdeY4s%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7530416674294516998',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oQMaABaBixIa4EBYhtjCFGQEbnqvCIipSUIhM~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=TIzROsFSv1M0sxqcTsMAEIWh1Wo%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7528870493839969542',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oMfQapDhgiD9y7vEZ6FvSEy9CvKdIgCfeECSMJ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=0u5t78hXF%2F6c2C3ZHebZ0hRQ7nI%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7527819042216774918',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oIf442EJCCCiKXg64NB7SQI4eEXfjLDyCiXgZx~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=0MZobn8QX7x%2B8q19YCapER%2Bkj4U%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7527084302333496582',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oErIQMdEUgCkBkof7FZNw6EQ1Dk1fKEVBCBNBJ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=BVt8RFKwqql4jvhsp%2BtN67k7Gr4%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7524879357026864389',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oMiQecu3CMe2fSU2MUXGgvgQDJj3G9R8g0CQd3~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=97JifchLiEwd%2Fp8Bje5mrvvVrlw%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7523011747913993528',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/ooGI8bpYQ7kAkhnErcfGeFEG1fTLISGAOeGhgA~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=%2FuvjyFWZy7yiL3ZTNdd%2F3oet3dk%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7522229433411915014',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oI0GakMji81SRIXBURAvB9MxiQUxo5BaTNidE~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=0Wmu6Akho3Lc99GJ%2FZ8aLcDlf1Q%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7519995395699707141',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oMQxgGUUajUxMkYFfv1B4FfN4eSAfgPBQejfSZ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=ohPVl3vkWiChBqJ6z1EHsgX0x3U%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7518085511307627781',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oQWSaQVmVUZxB28idAFBLLMviaBUBFyvIKExQ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=DDM9VG70pXRZ7XmS5kkqI%2B4SDgo%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7516253549135744262',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oQEaPEG6iPRi8xBIB30jQAMdYUm6ByWbjMjuS~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=Ezwrg6UqiX8WWbXNw7NESMre%2BQY%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7514096369410247992',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oMtrAGa3uB5QpBE5lnAHv4ECiMEiaIb1SUdp1~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=0HfznlkHYEITmlejPvC64GTc6Qg%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7501757791711874309',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oMQjABJDoBmkzRfFERG5qEEhwBMbfG2QUBIPI5~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=Y6xfz82o%2FTY41cP%2Fz%2BTqMSpfDBc%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7491762121651277111',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/o88DQgv9MfnnvNig93CfgS3VgFWeCPJC8QMSHQ~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=4HRtRsfih9qBS84zCEHDGkxkNzI%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },
    {
      link: 'https://www.tiktok.com/@teu.mx/video/7491053099218423045',
      img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/o01ixiAAkBzzfKYRko2tCLSPEvaHjAgiWjI2WB~tplv-tiktokx-origin.image?dr=14575&x-expires=1772049600&x-signature=qIQ0PoBThgbSg4qgTyharygru9E%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my',
    },*/
  ];

  faqItems: FaqItem[] = [
    {
      question: '¿Qué necesito para ser un PromoTEU?',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed cursus nunc at nisl viverra, vitae posuere ligula fermentum.',
    },
    {
      question: '¿Cuánto puedo ganar?',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed cursus nunc at nisl viverra, vitae posuere ligula fermentum.',
    },
    {
      question: '¿Cómo funciona la app?',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed cursus nunc at nisl viverra, vitae posuere ligula fermentum.',
    },
    {
      question: '¿Cómo formo mi cartera?',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed cursus nunc at nisl viverra, vitae posuere ligula fermentum.',
    },
    {
      question: '¿Cómo veo mis igresos?',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed cursus nunc at nisl viverra, vitae posuere ligula fermentum.',
    },
  ];

  openFaqIndex: number | null = 0;
  footerColorClass = 'footer-promotor';

  toggleFaq(index: number): void {
    this.openFaqIndex = this.openFaqIndex === index ? null : index;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  private parseCurrency(value: string): number {
    const limpio = value.replace(/[^0-9.]/g, '');
    const numero = parseFloat(limpio);
    if (!isFinite(numero) || numero < 0) {
      return 0;
    }
    return numero;
  }

  private formatCurrency(value: number): string {
    return value.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  onMontoInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const bruto = this.parseCurrency(target.value);
    this.simuladorMonto = bruto > 0 ? bruto.toString() : '';
  }

  onMontoBlur(event: Event): void {
    const target = event.target as HTMLInputElement;
    const bruto = this.parseCurrency(target.value);
    this.simuladorMonto = bruto > 0 ? bruto.toString() : '';
    target.value = bruto > 0 ? this.formatCurrency(bruto) : '';
    this.calcular();
  }

  onPlazoChange(plazo: number | string): void {
    const valor = Number(plazo);
    this.simuladorPlazo = Number.isFinite(valor) ? valor : this.simuladorPlazo;
    this.calcular();
  }

  private campoEsInvalido(valor: number): boolean {
    return valor < this.minValorSimulador || valor > this.maxValorSimulador;
  }

  private cotizar(monto: number, plazo: number): void {
    let multiplier: number;
    switch (plazo) {
      case 16:
        multiplier = 1.20672;
        break;
      case 20:
        multiplier = 1.25899;
        break;
      case 24:
        multiplier = 1.31264;
        break;
      case 28:
        multiplier = 1.36764;
        break;
      default:
        multiplier = 1.25899;
        break;
    }
    const totalAmount = monto * multiplier;
    const weeklyPayment = totalAmount / plazo;
    this.pagoSemanal = weeklyPayment;
    this.pagoTotal = totalAmount;
    this.pagoSemanalTexto = this.formatCurrency(weeklyPayment);
    this.pagoTotalTexto = this.formatCurrency(totalAmount);
  }

  calcular(): void {
    const monto = this.parseCurrency(this.simuladorMonto);
    const plazo = this.simuladorPlazo;
    if (this.campoEsInvalido(monto)) {
      this.pagoSemanal = 0;
      this.pagoTotal = 0;
      this.pagoSemanalTexto = '$0';
      this.pagoTotalTexto = '$0';
      return;
    }
    this.cotizar(monto, plazo);
  }

  scrollToFaq(event: Event, id: string): void {
    event.preventDefault();
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  animateOnHover(event: MouseEvent): void {
    const element = event.currentTarget as HTMLElement;
    if (element.classList.contains('animate__heartBeatSoft')) return;

    element.style.animationDelay = '0s'; // Clear delay for hover effect

    element.classList.add('animate__animated', 'animate__heartBeatSoft');
    element.addEventListener(
      'animationend',
      () => {
        element.classList.remove('animate__heartBeatSoft', 'animate__animated');
        element.style.animationDelay = '';
      },
      { once: true }
    );
  }

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target as HTMLElement;
            element.classList.add('active');
            observer.unobserve(element);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.animatedElements.forEach((el) => {
      this.observer?.observe(el.nativeElement);
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.scrollY = window.scrollY;
    this.updateParallax();
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    this.mouseX = (event.clientX / window.innerWidth - 0.5) * 2; // -1 to 1
    this.mouseY = (event.clientY / window.innerHeight - 0.5) * 2; // -1 to 1
    this.updateParallax();
  }

  private updateParallax(): void {
    if (this.parallaxBg) {
      // Fondo: se mueve con scroll (lento) y mouse (opuesto al mouse)
      const moveX = this.mouseX * -15; // Suave movimiento horizontal
      const moveY = this.scrollY * 0.2 + this.mouseY * -15; // Suave movimiento vertical
      this.parallaxBg.nativeElement.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
    }
  }

  goToPromotorForm() {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdl_dWgRd1KHzjKesnuKCOvOiBjutFZhH0LUF_YOLbPZjNM0w/viewform', '_blank');
  }
}
